// ObjGraphsBarHtml.jsx
import React from 'react';
import { connect } from 'react-redux';
import { getProgressBar, isJSON } from '../../../Utils/Utils';
import { objGraphsBarHtmlStyles } from './ObjGraphsBarHtmlCss';
import DrilldownList from '../ObjFields/DrilldownList';

class ObjGraphsBarHtml extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'graph', // 'graph' | 'list'
      drillCat1: null, // valeur de la catégorie choisie
    };
  }

  handleBack = () => this.setState({ mode: 'graph', drillCat1: null });

  render() {
    const { mode, drillCat1 } = this.state;
    const {
      data = [],
      objId,
      formulaCat1,
      extraCondition,
      optionsCat1,
      mini,
      profiles,
    } = this.props;

    let optionsArray;
    try {
      if (isJSON(optionsCat1)) {
        optionsArray = JSON.parse(optionsCat1);
      } else {
        optionsArray = optionsCat1;
      }
    } catch (e) {}
    const sum = data.reduce((acc, elem) => acc + parseInt(elem.result, 10), 0);
    // Trier les données selon optionsArray si disponible
    const sortedData = [...data].sort((a, b) => {
      const keyA = Object.keys(a)?.find((key) => key !== 'result');
      const keyB = Object.keys(b)?.find((key) => key !== 'result');

      const valueA = a[keyA];
      const valueB = b[keyB];

      if (optionsArray && Array.isArray(optionsArray)) {
        const indexA = optionsArray.findIndex((opt) => opt.value === valueA);
        const indexB = optionsArray.findIndex((opt) => opt.value === valueB);

        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
      }

      // fallback : tri alphabétique
      return valueA.toString().localeCompare(valueB.toString());
    });

    if (mode === 'list') {
      // Drilldown actif
      return (
        <div style={objGraphsBarHtmlStyles.container}>
          <DrilldownList
            objId={objId}
            formulaCat1={formulaCat1}
            formulaCat2={null}
            cat1={drillCat1}
            cat2={null}
            extraCondition={extraCondition}
            profiles={profiles}
            onBack={this.handleBack}
            // meta optionnelle (si on veut afficher badges/labels colorés)
            cat1Meta={(optionsArray || []).reduce((acc, o) => {
              acc[o.value] = {
                display: o.display ?? o.value,
                color: o.color,
                icon: o.icon,
              };
              return acc;
            }, {})}
            cat1Label={formulaCat1}
          />
        </div>
      );
    }

    // Vue graphique par défaut
    return (
      <div style={objGraphsBarHtmlStyles.container}>
        {sortedData.map((elem, ind) => {
          const key = Object.keys(elem)?.find((key) => key !== 'result');
          const valueCat1 = elem[key];
          const value =
            sum > 0 ? `${Math.round((elem.result / sum) * 100)}%` : `0%`;

          let colorToUse = '#228BE6';
          let iconToUse;
          let displayToUse = valueCat1;
          if (optionsArray && Array.isArray(optionsArray)) {
            const option = optionsArray?.find((o) => o.value === valueCat1);
            if (option) {
              colorToUse = option.color ?? colorToUse;
              iconToUse = option.icon;
              displayToUse = option.display ?? displayToUse;
            }
          }

          return (
            <div
              key={valueCat1}
              style={{ cursor: 'pointer' }}
              onClick={() =>
                this.setState({ mode: 'list', drillCat1: valueCat1 })
              }
            >
              {getProgressBar(
                value,
                displayToUse,
                colorToUse,
                '',
                mini ? 12 : 12,
                iconToUse
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

//-----------------------------------------------------------------------------------------------------------

function mapStateToProps(state) {
  return {
    profiles: state.objects?.profiles || {},
  };
}

export default connect(mapStateToProps)(ObjGraphsBarHtml);
